import styled from "styled-components";

const Icon = styled.a`
  text-decoration: none;
  margin: 5px;

  & svg {
    height: 30px;
    width: 30px;
    color: #64ffda;
    transition: transform 0.3s ease, color 0.3s ease;
  }

  & svg:hover {
    transform: scale(1.3);
  }
`;

export default Icon;
